module.exports = __webpack_public_path__ + "assets/img/001.a99059de.png";